module.exports = __webpack_public_path__ + "static/images/qianhai1.4f083da.png";